// extracted by mini-css-extract-plugin
module.exports = {"base":"twelveStoryOneAdsOneWidget-m__base__126_N","wrapper":"twelveStoryOneAdsOneWidget-m__wrapper__25h5I","ad-slot":"twelveStoryOneAdsOneWidget-m__ad-slot__1p49z"};